export default __webpack_public_path__ + "static/media/Step 3 (2) Image.4d7cd22e.png";